/*<!-- ============================================================================= -->
<!-- Alfinet Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->*/

$(document).ready(function() {
    $('[data-open-sidebar]').on('click', function() {
        $('.page-sidebar, .page-content').toggleClass('sidebar-open');
        $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
    });
});
